import { JSX } from 'react';
import { IMappedGroupSchedule, IMappedTeacherSchedule } from 'entities/types';

import {
  GroupRowTableSchedule,
  TeacherRowTableSchedule,
} from '../../rowTableSchedule';

export const makeRows = (
  data: IMappedGroupSchedule[] | IMappedTeacherSchedule[],
  isGroupSchedule: boolean,
) => {
  const rows: JSX.Element[] = [];
  if (isGroupSchedule) {
    data.forEach((item) => {
      rows.push(
        <GroupRowTableSchedule
          data={item as IMappedGroupSchedule}
          key={item.key}
        />,
      );
    });
  } else {
    data.forEach((item) => {
      rows.push(
        <TeacherRowTableSchedule
          data={item as IMappedTeacherSchedule}
          key={item.key}
        />,
      );
    });
  }

  if (data.length === 0) {
    rows.push(
      <div
        style={{
          width: '100%',
          textAlign: 'center',
          paddingTop: '27px',
          color: 'var(--black-light-26)',
          fontSize: '16px',
          fontWeight: 500,
        }}
      >
        Нет результатов
      </div>,
    );
  }

  return rows;
};
